// extracted by mini-css-extract-plugin
export default {"header":"ActionCategory_header__7HHUX","icon":"ActionCategory_icon__vzVfF"};